import { useSyncExternalStore } from "react";
import ContentService from "../utils/contentService";

export const useContentVersion = () =>
  useSyncExternalStore(
    ContentService.subscribe.bind(ContentService),
    ContentService.getVersion.bind(ContentService),
  );
